import { createSlice, current } from "@reduxjs/toolkit";
import * as Act from "./actions";
const initialState = {
  loading: false,
  HOME: [],
  totalCount: 0,
};
const slice = createSlice({
  name: "HOME",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getHome.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getHome.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      HOME: payload || [],
      totalCount: payload.totalcount || 0,
    }));
    builder.addCase(Act.getHome.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      HOME: [],
      totalCount: 0,
    }));
    builder.addCase(Act.viewHome.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.viewHome.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      HOME: payload || [],
      totalCount: payload.totalcount || 0,
    }));
    builder.addCase(Act.viewHome.rejected, (state, { payload }) => ({
      ...state,
      loading: false,
      error: payload || "Unknown error",
      HOME: [],
      totalCount: 0,
    }));
    builder.addCase(Act.AddContent.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.AddContent.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.AddContent.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // edit token package
    builder.addCase(Act.editHome.pending, (start, action) => ({
      ...start,
      loading: true,
    }));
    builder.addCase(
      Act.editHome.fulfilled,
      (state, { payload }) => (
        console.log(payload),
        {
          ...state,
          loading: false,
        }
      )
    );
    builder.addCase(Act.editHome.rejected, (state, action) => ({
      ...state,
      loading: false,
    }));
    // delete token package
    builder.addCase(Act.deleteHome.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(Act.deleteHome.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(Act.deleteHome.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || action.error;
    });
  },
});

export default slice;
